import { OrderBump } from './OrderBump'
import { formatMoney } from '@utils/moneyFormatter'
import { useTranslation } from 'react-i18next'
import { H1, H2, Stack, Text, XStack, YStack } from 'tamagui'
import { StatusBadge } from './StatusBadge'
import { useOrderDetails } from '@contexts/OrderDetailsContext'

export function Order() {
  const { t } = useTranslation('OrderDetails')

  const {
    relevantPayment,
    productTitle,
    subscription,
    items,
    id,
    createdAt,
    total,
    isSmartInstallmentORStrategySales,
    selectedItem,
  } = useOrderDetails()

  const status = subscription?.status || relevantPayment?.status

  // HET-3540: detalhe focado num item — título e valor são DO ITEM; o bloco de bumps sai
  // (cada item tem a própria tela a partir da listagem).
  const displayTitle = selectedItem
    ? `${selectedItem.product.name}${selectedItem.order_bump_item_id ? ` (${t('orderBumpBadge')})` : ''}`
    : productTitle
  const displayTotal =
    selectedItem && selectedItem.amount_cents != null
      ? formatMoney(selectedItem.amount_cents)
      : total

  return (
    <>
      <H1 color="$text-primary" fontSize="$font-size-md" ff="$mulishRegular">
        {t('title')}
      </H1>
      <YStack gap="$size.spacing-xxxs">
        <StatusBadge status={status} isSubscription={!!subscription} />
        <H2
          color="$text-primary"
          fontSize={'$font-size-sm'}
          ff="$mulishSemiBold"
          $gtSm={{
            ff: '$mulishBold',
            fontSize: '$font-size-md',
          }}
          $gtMd={{
            maxWidth: 760,
          }}
        >
          {displayTitle}
        </H2>
      </YStack>
      <OrderBump products={selectedItem ? [] : items} />
      <YStack gap="$size.spacing-xxxs">
        <YStack
          p="$size.spacing-xs"
          br="$border-radius-sm"
          borderWidth="$borderWidth.border-width-hairline"
          borderColor="$border-strong"
          gap="$size.spacing-xxs"
          $gtSm={{
            padding: 0,
          }}
          $gtMd={{
            maxWidth: 587,
          }}
        >
          <Stack
            flexDirection="column"
            gap="$size.spacing-xxs"
            $gtSm={{
              flexDirection: 'row',
              padding: '$size.spacing-md',
              gap: '$size.spacing-xsl',
            }}
          >
            <XStack>
              <Text
                textTransform="uppercase"
                color="$accent"
                ff="$mulishBold"
                fontSize="$font-size-xxs"
              >
                {t('orderId')}:{' '}
                <Text
                  color="$text-primary"
                  ff="$mulishRegular"
                  fontSize="$font-size-xxs"
                >
                  {id}
                </Text>
              </Text>
            </XStack>
            <XStack>
              <Text
                textTransform="uppercase"
                color="$accent"
                ff="$mulishBold"
                fontSize="$font-size-xxs"
              >
                {t('createdAt')}:{' '}
                <Text
                  color="$text-primary"
                  ff="$mulishRegular"
                  fontSize="$font-size-xxs"
                >
                  {createdAt}
                </Text>
              </Text>
            </XStack>
            <XStack>
              <Text
                textTransform="uppercase"
                color="$accent"
                ff="$mulishBold"
                fontSize="$font-size-xxs"
              >
                {isSmartInstallmentORStrategySales
                  ? t('amountPaid')
                  : t('amount')}
                :{' '}
                <Text
                  color="$text-primary"
                  ff="$mulishRegular"
                  fontSize="$font-size-xxs"
                >
                  {displayTotal}
                </Text>
              </Text>
            </XStack>
          </Stack>
        </YStack>
      </YStack>
    </>
  )
}
